<template>
<div>
	<section class="main content" id="main"></section>
	<section class="header" id="header">

		<br><br><br>
		<div class="container">

			<div class="phonest">
				<br>
				<br>
				<h2>Кондитерская<br>
					Наполеон</h2>
				<div class="headheight"></div>

				<div class="row">
					<div class="col-md-3">
						<div class="headtext">
						</div>
						<br>
					</div>
				</div>
			</div>
		</div>
		<br>
		<br>
		<br>
	</section>
	<section class="catalogmain" id="catalogmain">
		<br><br>
		<h2>Каталог</h2>
		<div class="container">

			<div class="centerall">
				<div class="row centerall"  >
					<div class="col-md-3 col-sm-12 centerall" v-for="cat in categories" >
						<a :href="'/catalogid/'+cat.id">
							<img  :src="cat.image"><br>
							<h3 class="centerall">{{cat.name}}</h3></a>
					</div>
				</div>
			</div>
		</div>
		<br><br>
	</section>

	<section id="about" class="about">
		<br><br>
		<div class="container">
			<div>
				<br><br>
				<h3>
					Из самых обыкновенных ингредиентов получаются самые вкусные десерты,
					у которых нет шансов быть забытыми на верхней полке холодильника.
					Только мука, яйца, молоко, масло и другие простые продукты входят в состав тортов,
					пирогов, печения и многих-многих иных сладостей, которые готовят в нашей кондитерской.
					Никаких готовых сухих смесей, консервантов и искусственных загустителей — только натуральные продукты
					и любовь к своему делу!
				</h3>
			</div>
		</div>
		<br><br>
	</section>

	<section id="contact" class="contact">
		<br>
		<div class="container">
			<h2>Контакты</h2>
			<br>
			<div class="centerall">
				<div class="row">
					<div class="col-md-6 col-sm-12"><br>
						<h3 v-show="message!=''">{{message}}</h3>
						<h3>Доставка осуществляется от 1000р</h3>

<!--						<a href="tel:{{$phone1[0]}}">-->
<!--							<br>{{$phone1[0]}}</a><br>-->
              <a :href="'tel:'+phone.phone">{{phone.phone}}</a> /
              <a :href="'tel:'+phone.phone2">{{phone.phone2}}</a> <span v-show="phone.phone2 && phone.phone2!==null"> / </span>
              <a :href="'tel:'+phone.phone3">{{phone.phone3}}</a>
              <br>
						<a href="viber://chat?number=79205000390">Viber</a> /
						<a href="https://wa.me/79205000390">WhatsApp</a> /
						<a href="https://t.me/NapoleonLipetsk">Telegram</a>

						<br>

						<div class="faicons">
<!--			         <a href="https://www.instagram.com/napoleon_48/"><i class="fa fa-instagram" aria-hidden="true"></i></a>-->
							<a href="https://vk.com/napoleon48"><i class="fa fa-vk" aria-hidden="true"></i></a>
							<a href="https://ok.ru/group/55319387963408"><i class="fa fa-odnoklassniki"
																															aria-hidden="true"></i></a>
							<a href="https://t.me/napoleon_48"><i class="fa fa-telegram" aria-hidden="true"></i></a>
						</div>
					</div>

					<div class="col-md-6 col-sm-12">
						<div class="adress">
							<h4>
								<span v-for="$item in filials">
										• {{$item.name}} ({{$item.time}}) {{$item.adress}} <br>
								</span>
							</h4>
						</div>
					</div>
				</div>
			</div>
		</div>

		<br>

	</section>
	<div class="trash_button cart" id="trash_button"  @click="$refs.modal.openModal()">
		<span id="count">{{ this.getCookie('count') }}</span>
	</div>
	<right-cart-widget v-bind:id="'cart-modal'" ref="modal"/>

</div>

</template>
<script>
export default {
	data() {
		return {
			categories: {},
      phone: [],
			message: '',
			// Create a new form instance
			form: new Form({
				id         : '',
				name       : '',
				description: '',
			}),
			filials : {},
			urls: {
				getdata: "/api/client/filial",
				category: "/api/client/category",
				message: "/api/client/mess",
				phone: "/api/client/phone",
			},
		}
	},
	methods: {
		getCookie(name) {
			const value = `; ${document.cookie}`;
			const parts = value.split(`; ${name}=`);
			if (parts.length === 2) {
				return parts.pop().split(';').shift();
			}
			return null;
		},
		getResults() {
			axios.get(this.urls.getdata).then(({ data }) => (this.filials = data.data));
		},
		getCategory(){
			axios.get(this.urls.category).then(({ data }) => (this.categories = data.data));
		},
		getMessage(){
			axios.get(this.urls.message).then(({ data }) => (this.message = data.data));
		},
    getPhone(){
			axios.get(this.urls.phone).then(({ data }) => (this.phone = data.data));
		},
	},
	created() {
    this.getPhone();
    this.getResults();
		 this.getCategory();
		 this.getMessage();
	}
	}
</script>
<style scoped>

</style>